import type { FaireProductEntity } from "../../entity_types/product";

export const p_5ta8x8b9qc: FaireProductEntity = {
  token: "p_5ta8x8b9qc",
  type: "product",
  name: "F4J69-FQ60 V NECK SMOCKED BODICE SUNDRESS",
  brandToken: "b_dkldnd6ff4",
  brandName: "ANGIE",
  imageUrl:
    "https://cdn.faire.com/fastly/8ca3e37027faa103ae62976b0daf3ac4c6c9e39cdc9dadee01644703f91adc46.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6ac06532e812ee2a4c760cdcc870a39a837b12a302d5ff850781de014641459f.jpeg",
    "https://cdn.faire.com/fastly/85934c3a5d10a12b5c4523024805242c4b9090887f0177350323b3dadfa61240.jpeg",
    "https://cdn.faire.com/fastly/1e488225eddb2e588ff7084619bd2d0992e74b9634ce3adb02472a09088c5dcf.jpeg",
    "https://cdn.faire.com/fastly/30f8bda48b34f2cd23db308edebb5de3b5b485a1be8f9cebe441ed6d2e282b60.jpeg",
    "https://cdn.faire.com/fastly/cc58aad2b6e81f0cdc65d06634ae7a897f0ad0df281ad6565c67a3ab775180d3.jpeg",
    "https://cdn.faire.com/fastly/684be0ae7635dac75b134d54d524b180cb561a7648e8703d06a79c2fd231a781.jpeg",
    "https://cdn.faire.com/fastly/02d01c7c14b6e6346cf32d6fbf8b812154e8ddaaa6ea3c50423340c36bfea7f7.jpeg",
  ],
  priceDollars: 19.5,
  description:
    "The F4J69-FQ60 V Neck Smocked Bodice Sundress from Angie is a perfect blend of retro and vintage style. This sundress features an abstract geometric design, making it a standout piece for any wardrobe. The smocked bodice and V-neckline add a feminine touch to this junior-sized, sleeveless sundress. Ideal for everyday wear or resort vacations, its vibrant multi-colored palette embodies Angie's fearless use of color and global lifestyle. Embrace the bold, poetic spirit of Angie with this mini sundress.",
  tags: [],
  msrpDollars: 39,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:55.821Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
